export default __webpack_public_path__ + "static/media/icn_check_green.7ba5dda3.svg";